/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/statistics.scss';
import Tab from '../../component/Inc/Tab';
import LineChart from '../../component/Inc/LineChart';
import Paging from '../../component/Inc/Paging';

function Sales() {
  const lineChartWidth = '100%';
  const lineChartHeight = '200px';

  //Tab Component
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '과목별', value: 0},
    {title: '담임별', value: 1},
    {title: '교사 월별', value: 2},
    {title: '교사 수업별', value: 3}
  ];

  //Linechartlabels
  const lineChartlabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  //sales data by Subject
  const lineChartDataSubject = {
    lineChartlabels,
    datasets: [
      {
        label: '첫수업',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '취소',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '중단',
        data: [3, 4, 6, 5, 8.5, 4.85, 2, 6, 7, 9, 3, 10],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      },
      {
        label: '인계',
        data: [1, 2.5, 3, 2.8, 2.1, 3.25, 2.4, 4, 3.7, 1.8, 4.3, 2.2],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#8f55ff'
      },
      {
        label: '종료',
        data: [4.1, 1.8, 2.1, 4.2, 3.8, 5.25, 5.85, 3.95, 6.2, 2, 3.9, 2.8],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#2bce71'
      }
    ]
  };

  //sales data by Teacher
  const lineChartDataTeacher = {
    lineChartlabels,
    datasets: [
      {
        label: '첫수업',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '취소',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '중단',
        data: [3, 4, 6, 5, 8.5, 4.85, 2, 6, 7, 9, 3, 10],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      },
      {
        label: '인계',
        data: [1, 2.5, 3, 2.8, 2.1, 3.25, 2.4, 4, 3.7, 1.8, 4.3, 2.2],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#8f55ff'
      },
      {
        label: '종료',
        data: [4.1, 1.8, 2.1, 4.2, 3.8, 5.25, 5.85, 3.95, 6.2, 2, 3.9, 2.8],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#2bce71'
      }
    ]
  };

  //sales data by Teacher month
  const lineChartDataTeacherMonth = {
    lineChartlabels,
    datasets: [
      {
        label: '첫수업',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '취소',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '중단',
        data: [3, 4, 6, 5, 8.5, 4.85, 2, 6, 7, 9, 3, 10],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      },
      {
        label: '인계',
        data: [1, 2.5, 3, 2.8, 2.1, 3.25, 2.4, 4, 3.7, 1.8, 4.3, 2.2],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#8f55ff'
      },
      {
        label: '종료',
        data: [4.1, 1.8, 2.1, 4.2, 3.8, 5.25, 5.85, 3.95, 6.2, 2, 3.9, 2.8],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#2bce71'
      }
    ]
  };

  //sales data by Teacher class
  const lineChartDataTeacherClass = {
    lineChartlabels,
    datasets: [
      {
        label: '첫수업',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '취소',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '중단',
        data: [3, 4, 6, 5, 8.5, 4.85, 2, 6, 7, 9, 3, 10],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      },
      {
        label: '인계',
        data: [1, 2.5, 3, 2.8, 2.1, 3.25, 2.4, 4, 3.7, 1.8, 4.3, 2.2],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#8f55ff'
      },
      {
        label: '종료',
        data: [4.1, 1.8, 2.1, 4.2, 3.8, 5.25, 5.85, 3.95, 6.2, 2, 3.9, 2.8],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#2bce71'
      }
    ]
  };

  return (
    <main className="com_container com_statistics p_sales">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu10_1 active">매출 통계</h2>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              </div>

              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
                <section className="com_board_search">
                  <article className="search">
                    <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                    <button className="com_btn gray ws s icon_search"></button>
                  </article>
                </section>
              </section>
            </div>

            <hr className="com_divider" />
            <div className="com_calendar_wrap has_option">
              <div className="year">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2023</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>

              <div className="com_count_wrapper">
                <div className="operators">
                  <div className="operators_label">
                    <span className="operators_count">총 영업자 수</span>
                    <span className="operators_value">98명</span>
                  </div>
                </div>
                <div className="turnover">
                  <div className="turnover_label">
                    <span className="turnover_count">총 매출액</span>
                    <span className="turnover_value">46,500,000</span>
                  </div>
                </div>
              </div>
            </div>
            {/* sales by subject */}
            {tabIdx === 0 && (
              <div className="subject_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">첫수업</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">취소</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">중단</span>
                        <div className="chart_slider chart_gray"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">인계</span>
                        <div className="chart_slider chart_indigo"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">종료</span>
                        <div className="chart_slider chart_green"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataSubject} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>과목</th>
                      <th>1월</th>
                      <th>2월</th>
                      <th>3월</th>
                      <th>4월</th>
                      <th>5월</th>
                      <th>6월</th>
                      <th>7월</th>
                      <th>8월</th>
                      <th>9월</th>
                      <th>10월</th>
                      <th>11월</th>
                      <th>12월</th>
                      <th>
                        <button className="arrow active" />
                        매출합
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>국어</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>영어</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>수학</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>과탐</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>사탐</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>논술</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>수시</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td>2023</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">3314,312,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td>2022</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>3314,312,000</td>
                    </tr>

                    <tr className="summarized_rows">
                      <td>증감율</td>
                      <td className="td_red">
                        <span className="arrow_blue">654</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue ">654</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue ">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue ">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue ">654</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue ">654</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue ">654</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue ">3214</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Paging />
              </div>
            )}

            {/* sales by teacher */}
            {tabIdx === 1 && (
              <div className="teacher_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">첫수업</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">취소</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">중단</span>
                        <div className="chart_slider chart_gray"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">인계</span>
                        <div className="chart_slider chart_indigo"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">종료</span>
                        <div className="chart_slider chart_green"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataTeacher} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                    <col width="{{ width: 'calc(100% / 15)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        <button className="arrow active" />
                      </th>
                      <th>
                        담임명
                        <button className="arrow active" />
                      </th>
                      <th>
                        1월
                        <button className="arrow active" />
                      </th>
                      <th>
                        2월
                        <button className="arrow active" />
                      </th>
                      <th>
                        3월
                        <button className="arrow active" />
                      </th>
                      <th>
                        4월
                        <button className="arrow active" />
                      </th>
                      <th>
                        5월
                        <button className="arrow active" />
                      </th>
                      <th>
                        6월
                        <button className="arrow active" />
                      </th>
                      <th>
                        7월
                        <button className="arrow active" />
                      </th>
                      <th>
                        8월
                        <button className="arrow active" />
                      </th>
                      <th>
                        9월
                        <button className="arrow active" />
                      </th>
                      <th>
                        10월
                        <button className="arrow active" />
                      </th>
                      <th>
                        11월
                        <button className="arrow active" />
                      </th>
                      <th>
                        12월
                        <button className="arrow active" />
                      </th>
                      <th>
                        매출합
                        <button className="arrow active" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td>목표</td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">9,780,000</div>
                      </td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>김담임103</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_red">57,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_red">8000,000</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>목표</td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">9,780,000</div>
                      </td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>김담임205</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_red">57,000</td>
                      <td className="td_red">57,000</td>
                      <td className="td_red">57,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_red">57,000</td>
                      <td className="td_red">57,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">768,000</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>목표</td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">9,780,000</div>
                      </td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>김담임103</td>

                      <td className="td_red">57,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_red">57,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_red">68,000</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>목표</td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">9,780,000</div>
                      </td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>김담임205</td>

                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>목표</td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">968,000</div>
                      </td>
                      <td>
                        <div className="value_box">9,780,000</div>
                      </td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>김담임205</td>

                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_red">9,780,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2023</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">9,780,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2022</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>8000,000</td>
                    </tr>

                    <tr className="summarized_rows">
                      <td colSpan="2">증감율</td>
                      <td className="td_red">
                        <span className="arrow_blue">654</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue ">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down ">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Paging />
                <div className='com_btn_wrap right'>
                  <button type='button' className='com_btn black xs btn_edit_pen_orange'>목표 수정하기</button>
                </div>
              </div>
            )}

            {/* sales by teacher and month */}
            {tabIdx === 2 && (
              <div className="teacher_month_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">첫수업</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">취소</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">중단</span>
                        <div className="chart_slider chart_gray"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">인계</span>
                        <div className="chart_slider chart_indigo"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">종료</span>
                        <div className="chart_slider chart_green"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataTeacherMonth} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>
                <select className="select">
                  <option value="과목 전체">과목 전체</option>
                </select>
                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                    <col width="{{ width: 'calc(100% / 16)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        순위
                        <button className="arrow active" />
                      </th>
                      <th>교사명</th>
                      <th>과목</th>

                      <th>
                        1월
                        <button className="arrow active" />
                      </th>
                      <th>
                        2월
                        <button className="arrow active" />
                      </th>
                      <th>
                        3월
                        <button className="arrow active" />
                      </th>
                      <th>
                        4월
                        <button className="arrow active" />
                      </th>
                      <th>
                        5월
                        <button className="arrow active" />
                      </th>
                      <th>
                        6월
                        <button className="arrow active" />
                      </th>
                      <th>
                        7월
                        <button className="arrow active" />
                      </th>
                      <th>
                        8월
                        <button className="arrow active" />
                      </th>
                      <th>
                        9월
                        <button className="arrow active" />
                      </th>
                      <th>
                        10월
                        <button className="arrow active" />
                      </th>
                      <th>
                        11월
                        <button className="arrow active" />
                      </th>
                      <th>
                        12월
                        <button className="arrow active" />
                      </th>
                      <th>
                        매출합
                        <button className="arrow active" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>7</td>
                      <td>김영업103</td>
                      <td>국어</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>김영업103</td>
                      <td>영어</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>김영업103</td>
                      <td>국어</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>김영업103</td>
                      <td>사탐</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>김영업103</td>
                      <td>국어</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>김영업103</td>
                      <td>수학</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>김영업103</td>
                      <td>국어</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>김영업103</td>
                      <td>영어</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>김영업103</td>
                      <td>사탐</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>김영업103</td>
                      <td>과탐</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="3">2023</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">4568,000</td>
                      <td className="td_point">9,780,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="3">2022</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>4568,000</td>
                      <td>8000,000</td>
                    </tr>

                    <tr className="summarized_rows">
                      <td colSpan="3">증감율</td>
                      <td className="td_red">
                        <span className="arrow_blue">654</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue ">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down ">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Paging />
              </div>
            )}

            {/* sales by teacher and class */}
            {tabIdx === 3 && (
              <div className="teacher_class_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">첫수업</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">취소</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">중단</span>
                        <div className="chart_slider chart_gray"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">인계</span>
                        <div className="chart_slider chart_indigo"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">종료</span>
                        <div className="chart_slider chart_green"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataTeacherClass} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                    <col width="{{ width: 'calc(100% / 13)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        순위
                        <button className="arrow active" />
                      </th>
                      <th>
                        교사명
                        <button className="arrow active" />
                      </th>
                      <th>과목</th>
                      <th>학생수</th>
                      <th>시수</th>
                      <th>
                        수업 수
                        <button className="arrow active" />
                      </th>
                      <th>
                        타임 수
                        <button className="arrow active" />
                      </th>
                      <th>
                        취소
                        <button className="arrow active" />
                      </th>
                      <th>
                        중단
                        <button className="arrow active" />
                      </th>
                      <th>
                        인계
                        <button className="arrow active" />
                      </th>
                      <th>
                        종료
                        <button className="arrow active" />
                      </th>
                      <th>유지율%</th>
                      <th>
                        매출합
                        <button className="arrow active" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>7</td>
                      <td>홍길동103</td>
                      <td>국어</td>
                      <td>123/546</td>
                      <td>45,000</td>
                      <td>123</td>
                      <td>12</td>
                      <td>12</td>
                      <td>21</td>
                      <td>45</td>
                      <td>21</td>
                      <td>97.6</td>

                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>홍길동103</td>
                      <td>영어</td>
                      <td>123/546</td>
                      <td>45,000</td>
                      <td>123</td>
                      <td>12</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>97.6</td>

                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>홍길동103</td>
                      <td>국어</td>
                      <td>123/546</td>
                      <td>45,000</td>
                      <td>123</td>
                      <td>12</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>97.6</td>

                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>홍길동103</td>
                      <td>사탐</td>
                      <td>123/546</td>
                      <td>45,000</td>
                      <td>123</td>
                      <td>12</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>97.6</td>

                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>홍길동103</td>
                      <td>국어</td>
                      <td>123/546</td>
                      <td>45,000</td>
                      <td>123</td>
                      <td>12</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>97.6</td>

                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>홍길동103</td>
                      <td>수학</td>
                      <td>123/546</td>
                      <td>45,000</td>
                      <td>123</td>
                      <td>12</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>97.6</td>

                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>홍길동103</td>
                      <td>국어</td>
                      <td>123/546</td>
                      <td>45,000</td>
                      <td>123</td>
                      <td>12</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>97.6</td>

                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>홍길동103</td>
                      <td>영어</td>
                      <td>123/546</td>
                      <td>45,000</td>
                      <td>123</td>
                      <td>12</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>97.6</td>

                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>홍길동103</td>
                      <td>사탐</td>
                      <td>123/546</td>
                      <td>45,000</td>
                      <td>123</td>
                      <td>12</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>97.6</td>

                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>홍길동103</td>
                      <td>과탐</td>
                      <td>123/546</td>
                      <td>45,000</td>
                      <td>123</td>
                      <td>12</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>97.6</td>

                      <td className="td_point">4568,000</td>
                    </tr>

                    <tr className="summarized_rows">
                      <td colSpan="3">2023</td>
                      <td className="td_point">78/312</td>
                      <td className="td_point">50,000</td>
                      <td className="td_point">120</td>
                      <td className="td_point">230</td>
                      <td className="td_point">32</td>
                      <td className="td_point">45</td>
                      <td className="td_point">312</td>
                      <td className="td_point">31</td>
                      <td className="td_point">97.6</td>
                      <td className="td_point">212,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="3">2022</td>
                      <td>35/312</td>
                      <td>50,000</td>
                      <td>30</td>
                      <td>830</td>
                      <td>654</td>
                      <td>6</td>
                      <td>64</td>
                      <td>654</td>
                      <td>97.6</td>
                      <td>45,000</td>
                    </tr>

                    <tr className="summarized_rows">
                      <td colSpan="3">증감율</td>
                      <td className="td_red">
                        <span className="arrow_blue">654</span>
                      </td>
                      <td className="td_red">
                        <span className="arrow_blue ">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down ">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Paging />
              </div>
            )}
          </div>
        </section>
      </div>
    </main>
  );
}

export default Sales;
